import { createAction, createAsyncAction } from 'typesafe-actions';

import {
  ChangePasswordPayload,
  CreateUserPayload,
  PhoneTypeListTypes,
  PreferredCurrencyTypes,
  ResetPasswordPayload,
  RolesListTypes,
  UserDetailsTypes,
} from './types';

export const getRoles = createAsyncAction(
  'users/getRoles/request',
  'users/getRoles/success',
  'users/getRoles/failure',
)<undefined, { data: RolesListTypes[] }, undefined>();

export const getUserDetail = createAsyncAction(
  'users/getUserDetail/request',
  'users/getUserDetail/success',
  'users/getUserDetail/failure',
)<undefined, { data: UserDetailsTypes }, undefined>();

export const updateUserDetail = createAsyncAction(
  'users/updateUserDetail/request',
  'users/updateUserDetail/success',
  'users/updateUserDetail/failure',
)<undefined, { data: UserDetailsTypes }, undefined>();

export const blockUsers = createAsyncAction(
  'users/blockUsers/request',
  'users/blockUsers/success',
  'users/blockUsers/failure',
)<undefined, undefined, undefined>();

export const unBlockUsers = createAsyncAction(
  'users/unBlockUsers/request',
  'users/unBlockUsers/success',
  'users/unBlockUsers/failure',
)<undefined, undefined, undefined>();

export const getPhoneType = createAsyncAction(
  'users/getPhoneType/request',
  'users/getPhoneType/success',
  'users/getPhoneType/failure',
)<undefined, { data: PhoneTypeListTypes[] }, undefined>();

export const createUsers = createAsyncAction(
  'users/createUsers/request',
  'users/createUsers/success',
  'users/createUsers/failure',
)<undefined, { data: CreateUserPayload }, undefined>();

export const resetPassword = createAsyncAction(
  'users/resetPassword/request',
  'users/resetPassword/success',
  'users/resetPassword/failure',
)<undefined, { data: ResetPasswordPayload }, undefined>();

export const changePassword = createAsyncAction(
  'users/changePassword/request',
  'users/changePassword/success',
  'users/changePassword/failure',
)<undefined, { data: ChangePasswordPayload }, undefined>();

export const setPreferredCurrency = createAction('users/setPreferredCurrency')<{
  currency: PreferredCurrencyTypes;
}>();
